import { render, staticRenderFns } from "./LbaAudio.vue?vue&type=template&id=6a270edd"
import script from "./LbaAudio.vue?vue&type=script&lang=js"
export * from "./LbaAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports